import { isValidCUITCUIL } from "./utils";


const insuredPersonValidationFormRules = {
    documentType: [{ required: true, message: 'Debe ingresar un tipo de documento' }],
    document: [{ required: true, message: 'Debe ingresar un numero de CUIT' },

    {
        validator: (_, value) =>
            (!value || isValidCUITCUIL(value)) ? Promise.resolve() : Promise.reject(new Error('Nro de CUIT/CUIL inválido'))
    }],
    policy: [{ required: true, message: 'Debe ingresar un número de póliza' }]
}


const phoneCodeRule = [
    { required: true, message: 'Debe ingresar un código de área' },
    {
        pattern: /^[1-3][0-9]*$/,
        message: 'Código de área inválido'
    },
    {
        min: 2,
        message: 'Debe ingresar como mínimo 2 dígitos'
    }
]

const phoneNumberRule = [
    { required: true, message: 'Debe ingresar un nro de celular' },
    {
        pattern: /^[0-9]*$/,
        message: 'Nro de celular inválido'
    },
    // {
    //     min: 6,
    //     message: 'Debe ingresar como mínimo 6 dígitos'
    // },

]

const phoneCompanyRule = [
    { required: true, message: 'Debe ingresar una compañia de celular' }
]

const passwordRule = [
    {
        required: true,
        message: 'Debe ingresar una contraseña',
    },

]

const confirmPasswordRule = [
    {
        required: true,
        message: 'Debe confirmar la contraseña',
    },
    ({ getFieldValue }) => ({
        validator(_, value) {
            if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
            }
            return Promise.reject(new Error('Las constraseñas no coinciden'));
        },
    })
]

const registerFormRules = {
    email: [
        { required: true, message: 'Debe ingresar un email' },
        {
            pattern: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: 'Email inválido'
        }
    ],
    phoneCode: [
        ...phoneCodeRule
    ],
    phoneNumber: [
        ...phoneNumberRule,

        ({ getFieldValue }) => ({
            validator(_, value) {
                const phoneCode = getFieldValue('phoneCode');
                const phoneNumber = value;
                return validateNumberOfDigitsPhoneNumber(phoneCode, phoneNumber)
            },
        })
    ],
    phoneCompany: [
        ...phoneCompanyRule
    ],
    phoneCodeX: [
        ...phoneCodeRule
    ],
    phoneNumberX: [
        ...phoneNumberRule
    ],
    phoneCompanyX: [
        ...phoneCompanyRule
    ],
    password: [
        ...passwordRule
    ],
    confirmPassword: [
        ...confirmPasswordRule
    ]
}


const validateNumberOfDigitsPhoneNumber = (phoneCode, phoneNumber) => {
    if (phoneCode) {
        const phoneCodeDigits = phoneCode.length
        const requiredDigits = 10 - phoneCodeDigits

        if ((!phoneNumber) || ((phoneNumber.length) === requiredDigits)) {
            return Promise.resolve()
        }

        return Promise.reject(new Error(`Debe ingresar ${requiredDigits} digitos`));
    }
    else return Promise.resolve();

}
export { insuredPersonValidationFormRules, registerFormRules, validateNumberOfDigitsPhoneNumber };